const superSubscriberMockData = {
	"first_name": "Ida",
	"last_name": "Hartman ",
	"street": "Stonewall Court",
	"street_number": "661",
	"full_address": "661 Stonewall Ct, Stone Mountain, GA 30087, USA",
	"apartment": "52",
	"zip": "30087",
	"city": "Stone Mountain",
	"phone": "123456789",
	"email": "kuku1988@netscape.net",
	"instructions": "lulu kuku nunu bubu",
	"market_id": 1,
	"state": "GA",
	"latitude": 33.8027736,
	"longitude": -84.09072689999999,
	"super_subscriber_id": "123"
}

export default superSubscriberMockData;